const STORAGE_KEY = 'osma:font-pane';

export const FONT_OPTIONS = {
  'Arial Narrow': {
    family: '"Arial Narrow", Arial, Helvetica, sans-serif',
    hasMedium: false,
  },
  'ABC Monument Grotesk': {
    family: '"ABC Monument Grotesk", Arial, Helvetica, sans-serif',
    hasMedium: true,
  },
  'ABC Monument Grotesk SemiMono': {
    family: '"ABC Monument Grotesk SemiMono", Arial, Helvetica, sans-serif',
    hasMedium: true,
  },
  'Scto Grotesk A': {
    family: '"Scto Grotesk A", Arial, Helvetica, sans-serif',
    hasMedium: false,
  },
  'Scto Grotesk B': {
    family: '"Scto Grotesk B", Arial, Helvetica, sans-serif',
    hasMedium: false,
  },
};

const DEFAULTS = {
  family: 'Scto Grotesk B',
  medium: false,
  italic: true,
  fontSize: 16,
  pageMargin: 28,
  pageMarginTouched: false,
  hidden: true,
};

export function loadFontPaneState() {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return { ...DEFAULTS, ...saved, ...(saved?.family in FONT_OPTIONS ? {} : { family: DEFAULTS.family }) };
  } catch (error) {
    return { ...DEFAULTS };
  }
}

export function saveFontPaneState(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    // Private browsing / quota errors: settings just won't persist across reloads.
  }
}

export function applyDesignVars(state) {
  const option = FONT_OPTIONS[state.family] ?? FONT_OPTIONS[DEFAULTS.family];
  const root = document.documentElement.style;
  root.setProperty('--font-family', option.family);
  root.setProperty('--font-weight', option.hasMedium && state.medium ? '500' : '400');
  root.setProperty('--font-style', state.italic ? 'italic' : 'normal');
  root.setProperty('--font-size', `${state.fontSize}px`);
  // Each layout rule falls back to its own original (pre-tweakpane) margin value,
  // e.g. 32px sides vs 28px top/bottom — only override once the user actually
  // picks a margin, otherwise setting one number here would flatten those on load.
  if (state.pageMarginTouched) {
    root.setProperty('--page-margin', `${state.pageMargin}px`);
  }
}
